export default __webpack_public_path__ + "static/media/Charge and Cover.af582faf.png";